// extracted by mini-css-extract-plugin
module.exports = {"claimRow":"ClaimPetRow_claimRow_2V3SH","petImg":"ClaimPetRow_petImg_1trnb"};